import { render } from "./PageInscription.vue?vue&type=template&id=0c4a7770&scoped=true&ts=true"
import script from "./PageInscription.vue?vue&type=script&lang=ts"
export * from "./PageInscription.vue?vue&type=script&lang=ts"

import "./PageInscription.vue?vue&type=style&index=0&id=0c4a7770&scoped=true&lang=scss"

import exportComponent from "/var/www/html/devcwmserver.com/taca/client/staging/RACA_FRONTEND/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4a7770"]])

export default __exports__